export interface DistributePolicyConnection {
    targetSid: number;
    targetSidName: string;
    targetSidLevel: string;
    distributePolicyState: DistributePolicyState;
}

export enum DistributePolicyState {
    VALID = 'VALID',
    INVALID_SERVICE_LEVEL = 'INVALID_SERVICE_LEVEL',
    INVALID_EQUAL = 'INVALID_EQUAL',
    INVALID_PENDING = 'INVALID_PENDING',
    INVALID_SMART_POLICY = 'INVALID_SMART_POLICY',
    INVALID_MAINTENANCE = 'INVALID_MAINTENANCE',
    INVALID_SCHEDULED = 'INVALID_SCHEDULED'
}
